export type PlatformCustomerErrorId =
  (typeof PlatformCustomerError.Id)[keyof typeof PlatformCustomerError.Id];

export class PlatformCustomerError extends Error {
  static readonly Id = {
    AlreadyExists: 'already_exists',
    CreateFailed: 'create_failed',
  } as const;

  public readonly id: PlatformCustomerErrorId;

  constructor(id: PlatformCustomerErrorId) {
    super(id);
    this.name = 'PlatformCustomerError';
    this.id = id;
  }
}
